"use strict";
// write code here
var list = document.querySelector("ul");
function getSalary(li) {
    return Number(li.dataset.salary.replace(/[^0-9.-]/g, ""));
}
function sortList(listData) {
    var items = Array.from(listData.children);
    items.sort(function(a, b) {
        return getSalary(b) - getSalary(a);
    });
    items.forEach(function(item) {
        return list.appendChild(item);
    });
}
function getEmployees(listData) {
    return Array.from(listData.children).map(function(li) {
        return {
            name: li.innerText,
            position: li.dataset.position,
            salary: getSalary(li),
            age: li.dataset.age
        };
    });
}
sortList(list);
getEmployees(list);

//# sourceMappingURL=index.3ad07d2d.js.map
